/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module TrafficLogsModule
 */

import {
    Component,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import { aviMediumDateFormatWithSec } from 'ng/modules/core/pipes/avi-date.pipe';

import { TrafficLogListExpandedContentStore } from '../traffic-log-list-expanded-content.store';
import { ITrafficLogsStates, TrafficLogsStore } from '../../traffic-logs.store';
import { FilterOperatorType, VsAppProfileType } from '../../../../logs.types';
import * as l10n from './traffic-log-list-expanded-content-summary.l10n';

import './traffic-log-list-expanded-content-summary.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Component for displaying Summary section in traffic log expandeded content.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'traffic-log-list-expanded-content-summary',
    templateUrl: './traffic-log-list-expanded-content-summary.component.html',
})
export class TrafficLogListExpandedContentSummaryComponent {
    @ViewChild('policiesAppliedFieldTemplateRef')
    public readonly policiesAppliedFieldTemplateRef: TemplateRef<HTMLElement>;

    public readonly vsAppProfileType$ = this.trafficLogsStore.vsAppProfileType$;

    public readonly VsAppProfileType = VsAppProfileType;

    public readonly applicationLog$ = this.trafficLogListExpandedContentStore.applicationLog$;

    public readonly connectionLog$ = this.trafficLogListExpandedContentStore.connectionLog$;

    public readonly ssl$ = this.trafficLogListExpandedContentStore.ssl$;

    public readonly hasAuthenticationLogs$ =
        this.trafficLogListExpandedContentStore.hasAuthenticationLogs$;

    public readonly icapLog$ = this.trafficLogListExpandedContentStore.icapLog$;

    public readonly wafLog$ = this.trafficLogListExpandedContentStore.wafLog$;

    public readonly botManagementLog$ = this.trafficLogListExpandedContentStore.botManagementLog$;

    public readonly datascriptInfo$ = this.trafficLogListExpandedContentStore.datascriptInfo$;

    public readonly FilterOperatorType = FilterOperatorType;

    /**
     * Format string that specifies date transformation to seconds.
     */
    public readonly timeFormat = aviMediumDateFormatWithSec;

    /**
     * Get global keys from source bundles for template usage.
     */
    public readonly globalL10nKeys = globalL10nKeys;

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    constructor(
        private readonly trafficLogsStore: TrafficLogsStore<ITrafficLogsStates>,
        private readonly trafficLogListExpandedContentStore: TrafficLogListExpandedContentStore,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
